import React, { useMemo, useRef, useState } from "react";
import {
    Box,
    Flex,
    Button,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Heading,
    Stack,
    TableContainer,
    Image,
    Card,
    CardBody,
    Spinner,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Textarea,
    FormControl,
    FormLabel,
} from "@chakra-ui/react";
import {
    XCircle,
    CheckCircle,
} from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    getQuoteDetailById,
    sendQuoteEmail,
    approveQuote,
    rejectQuote,
} from "../../../../redux/api/admin/quoteApi";
import { useEffect } from "react";
import { getProduct } from "../../../../redux/reduxApi/admin/ProductReduxApi";
import { useDispatch, useSelector } from "react-redux";
import "./QuoteDetail.css";
import { toast } from "react-toastify";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getClientList } from "../../../../redux/reduxApi/admin/ClientReduxApi";
import { getCategoryList } from "../../../../redux/reduxApi/admin/CategoryReduxApi";
import { getShadeNumberList } from "../../../../redux/reduxApi/admin/ShadeReduxApi";
import { getOrganisationDetailById } from "../../../../redux/api/admin/OrgApi";
import { getTermsAndConditionList } from "../../../../redux/reduxApi/admin/termsAndConditionsListRedux";
import { getMotorsList } from "../../../../redux/reduxApi/admin/MotorizationReduxApi";
import { getColoursList } from "../../../../redux/reduxApi/admin/ColourReduxApi";
import { getEmployeesList } from "../../../../redux/reduxApi/admin/EmployeesReduxApi";
import { addNotes } from "../../../../redux/api/admin/NotesApi";
import { getDealDetailById, updateDeal } from "../../../../redux/api/admin/dealApi";

export default function QuotePublicDetail({ }) {
    const componentRef = useRef();
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const quoteId = id;
    // const toast = useToast();
    console.log("quoteId", quoteId);

    // Modal states
    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
    const [rejectComment, setRejectComment] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [estimate, setEstimate] = useState({});
    const [billTo, setBillTo] = useState({ name: "", address: [] });
    const [shipTo, setShipTo] = useState({ name: "", address: [] });
    const categoryList = useSelector((state) => state.category.category);
    const [employees, setEmployees] = useState([]);
    const [quoteDataNew, setQuoteDataNew] = useState([]);
    console.log("quoteDataNew", quoteDataNew);
    const [termsText, setTermsText] = useState("");
    const [motorData, setMotorData] = useState([]);
    const [colourData, setColourData] = useState([]);

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString("en-GB");
    };

    useEffect(() => {
        if (quoteDataNew?.termsAndCondition) {
            dispatch(getTermsAndConditionList({ size: 100 }))
                .then((res) => {
                    const list = res?.payload?.data?.termAndConditions || [];

                    const matched = list.find(
                        (item) =>
                            String(item.ROWID) ===
                            String(quoteDataNew.termsAndCondition)
                    );

                    if (matched) {
                        setTermsText(matched.termsAndConditions);
                    }
                })
                .catch((err) => {
                    console.error("Error fetching terms:", err);
                });
        }
    }, [quoteDataNew?.termsAndCondition, dispatch]);


    useEffect(() => {
        if (quoteId) {
            setLoading(true);
            getQuoteDetailById(quoteId)
                .then((response) => {
                    console.log("GetQuoteById---->", response);
                    console.log("Response success:", response.data.success);
                    console.log("Response data:", response.data);
                    const quoteData = response.data?.quotation || response.data?.data || response.data;
                    if (quoteData) {
                        console.log("Quote Data:", quoteData);
                        setQuoteDataNew(quoteData); // Set the quote data

                        // Map the API data to component state
                        setItems(quoteData.items || []);

                        // Set estimate data
                        setEstimate({
                            date: formatDate(quoteData.quoteDate),
                            expiry: "", // You might need to calculate this or get from API
                            reference: quoteData.refrenceNo,
                            quoteNo: quoteData.quoteNo,
                            subTotal: quoteData.subTotal,
                            total: quoteData.total,
                            shippingCharges: quoteData.shippingCharges,
                            roundOff: quoteData.roundOff,
                            status: quoteData.status,
                            quoteOwner: quoteData.quoteOwner,
                            checkedBy: quoteData.checkedBy,
                            clientReferenceNo: quoteData.clientReferenceNo,
                        });

                        setBillTo({
                            name: quoteData.customerName || "",
                            address: [quoteData.email || ""].filter((line) => line),
                        });

                        setShipTo({
                            name: quoteData.customerName || "",
                            address: [
                                quoteData.recipientPhnNo
                                    ? `Phone: ${quoteData.recipientPhnNo}`
                                    : "",
                            ].filter((line) => line),
                        });
                    } else {
                        console.error("No quote data found in response");
                    }
                })
                .catch((error) => {
                    console.log({ error });
                    toast({
                        title: "Error fetching quote details",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [quoteId]);

    useEffect(() => {
        dispatch(getMotorsList({ page: 1, size: 100 }))
            .then((response) => {
                const motors = response?.payload?.data?.motors || [];
                setMotorData(motors);
            })
            .catch((error) => {
                console.error("Error fetching motors:", error);
            });
    }, [dispatch]);

    useEffect(() => {
        dispatch(getColoursList())
            .then((response) => {
                const colours = response?.payload?.data?.colours || [];
                setColourData(colours);
            })
            .catch((error) => {
                console.error("Error fetching motors:", error);
            });
    }, [dispatch]);

    useEffect(() => {
        dispatch(getEmployeesList({ page: 1, size: 100, limit: 100 }))
            .then((res) => {
                const data = res?.payload?.data?.employees || [];
                setEmployees(data);
            })
            .catch((err) => {
                console.error("Error fetching employees:", err);
            });
    }, [dispatch]);

    // Calculate total quantity from items
    const calculateTotalQuantity = () => {
        return items.reduce(
            (total, item) => total + (parseFloat(item.quantity) || 0),
            0,
        );
    };

    // Calculate total discount from items
    const calculateTotalDiscount = () => {
        return items.reduce(
            (total, item) => total + (parseFloat(item.discount) || 0),
            0,
        );
    };

    // Inventory data fetching (your existing code)
    const [inventoryData, setInventoryData] = useState([]);
    const [inventoryAllData, setinventoryAllData] = useState([]);
    console.log("inventoryAllData", inventoryAllData);

    const [currentPage] = useState(1);


    useEffect(() => {
        dispatch(getProduct({ page: currentPage, size: 30, limit: 30 }))
            .then((response) => {
                console.log("response--->", response);
                console.log("inventoryData-->", response.payload.inventory || []);
                setInventoryData(response.payload.inventory || []);
            })
            .catch((error) => {
                console.error("Error fetching Company data:", error);
            });
    }, [dispatch]);

    const inventoryLookUp = useMemo(() => {
        return inventoryData?.map((item) => ({
            label: item?.itemName,
            value: item.ROWID,
            shadeNumber: item?.shadeNumber,
            hscCode: item?.hscCode,
        }));
    }, [inventoryData]);

    useEffect(() => {
        if (!inventoryLookUp) {
            return;
        }
        setinventoryAllData(inventoryLookUp);
    }, [inventoryLookUp]);

    const itemName = (id) => {
        const itemData = inventoryAllData.filter((item) => item?.value === id);
        return itemData[0]?.label;
    };

    const [shadeData, setShadeAllData] = useState([]);
    console.log("shadeData", shadeData);

    useEffect(() => {
        dispatch(getShadeNumberList({ page: currentPage, size: 30, limit: 30 }))
            .then((response) => {
                console.log("response", response);

                const data = response.payload?.data?.shades || [];

                console.log("data", response.payload);

                setShadeAllData(data);
            })
            .catch((error) => {
                console.error("Error fetching Company data:", error);
            });
    }, [dispatch]);

    const shadeDataLookUp = useMemo(() => {
        return shadeData?.map((item) => ({
            label: item.shadeNo,
            value: item.ROWID,
        }));
    }, [shadeData]);

    console.log("shadeDataLookUp", shadeDataLookUp);

    const shadName = (rowid) => {
        const itemData = shadeDataLookUp.filter((item) => item?.value === rowid);
        return itemData[0]?.label;
    };

    const [categoryOptions, setCategoryOptions] = useState([]);
    console.log("categoryOptions", categoryOptions);

    // Fetch category list for parent category dropdown
    useEffect(() => {
        dispatch(getCategoryList());
    }, [dispatch]);

    // Prepare category options for dropdown
    useEffect(() => {
        const options = categoryList.map((item) => ({
            label: item.name,
            value: item.ROWID,
        }));

        setCategoryOptions(options);
    }, [categoryList]);

    const categoryName = (id) => {
        const itemData = categoryOptions.filter((item) => item?.value === id);
        return itemData[0]?.label;
    };


    // Inventory data fetching (your existing code)
    const [clientData, setClientData] = useState([]);

    useEffect(() => {
        dispatch(getClientList({ page: currentPage, size: 30, limit: 30 }))
            .then((response) => {
                // console.log("response--->",response);
                console.log("inventoryData-->", response.payload?.data?.contact || []);
                setClientData(response.payload?.data?.contact || []);
            })
            .catch((error) => {
                console.error("Error fetching Company data:", error);
            });
    }, [dispatch]);

    const clientLookUp = useMemo(() => {
        return clientData?.map((item) => ({
            label: `${item?.firstName} ${item?.lastName}` || "Unnamed Client",
            value: item.ROWID,
        }));
    }, [clientData]);
    console.log("clientLookUp", clientLookUp);

    const motorMap = useMemo(() => {
        const map = {};
        motorData.forEach(item => {
            map[item.ROWID] = {
                name: item.motorName,
                price: item.motorPrice
            };
        });
        return map;
    }, [motorData]);


    const colourMap = useMemo(() => {
        const map = {};
        colourData.forEach(item => {
            map[item.ROWID] = item.colour;
        });
        return map;
    }, [colourData]);

    const employeeMap = useMemo(() => {
        const map = {};
        employees.forEach((emp) => {
            map[emp.ROWID] =
                `${emp.firstName || ""} ${emp.lastName || ""}`.trim();
        });
        return map;
    }, [employees]);

    const clientName = (rowid) => {
        const itemData = clientLookUp.filter((item) => item?.value === rowid);
        return itemData[0]?.label;
    };



    const organisationId = quoteDataNew?.organisationName || null;
    const dealId = quoteDataNew?.dealID || null;

    const [orgDetailData, setOrgDetailData] = useState(null);
    const [dealData, setDealData] = useState(null);

    useEffect(() => {
        if (organisationId) {
            setLoading(true);
            getOrganisationDetailById(organisationId)
                .then((response) => {
                    console.log("GetQuoteById---->", response);
                    if (response.data.success) {
                        const orgData = response.data.organisation;
                        setOrgDetailData(orgData);
                    }
                })
                .catch((error) => {
                    console.log({ error });
                    toast({
                        title: "Error fetching quote details",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [organisationId, toast]);
    useEffect(() => {
        if (dealId) {
            setLoading(true);
            getDealDetailById(dealId)
                .then((response) => {
                    console.log("GETDEAL---->", response);
                    if (response.data.success) {
                        // backend returns: { success: true, deals: fullDeal }
                        // where fullDeal is an array with a single deal row
                        const deal = response.data?.deals?.[0] || null;
                        setDealData(deal);
                    }
                })
                .catch((error) => {
                    console.log({ error });
                    toast({
                        title: "Error fetching deal details",
                        status: "error",
                        duration: 3000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [dealId, toast]);

    // Add this helper function to parse the logoUrl string
    // const parseLogoUrl = (logoUrlString) => {
    //     if (!logoUrlString) return null;

    //     try {
    //         // The logoUrl is a string that looks like an object
    //         // We need to convert it to a proper object
    //         // Remove the curly braces and split by commas
    //         const cleanStr = logoUrlString.replace(/[{}]/g, "");
    //         const pairs = cleanStr.split(", ");

    //         const logoObj = {};
    //         pairs.forEach((pair) => {
    //             const [key, ...valueParts] = pair.split("=");
    //             const value = valueParts.join("="); // In case the value contains '='
    //             logoObj[key.trim()] = value.trim();
    //         });

    //         return logoObj.filePath || null;
    //     } catch (error) {
    //         console.error("Error parsing logoUrl:", error);
    //         return null;
    //     }
    // };

    // Then in your component, use it like this:
    // const logoImageUrl = orgDetailData?.logoUrl
    //     ? parseLogoUrl(orgDetailData.logoUrl)
    //     : "https://i.postimg.cc/d1tpgLGb/loginlogo.webp"; // fallback image

    const isWidthandDropVisible = quoteDataNew?.isShowDropandWidthinPdf || false;

    const handleApproveClick = () => {
        setIsApproveModalOpen(true);
    };

    const handleRejectClick = () => {
        setIsRejectModalOpen(true);
    };

    const handleApproveConfirm = async () => {
        try {
            setIsSubmitting(true);
            if (!quoteId || quoteId === "") {
                toast({
                    title: "Error",
                    description: "Quotation information is missing",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }
            const response = await approveQuote(quoteId);
console.log("Approve Quote Response:", response);
            if (response.data.success) {

                toast.success("Quotation approved successfully");

                setIsApproveModalOpen(false);
                const updateData = {
                    ...dealData,
                    createdBy: dealData?.createdBy.ROWID || null,
                    modifiedBy: dealData?.modifiedBy.ROWID || null,
                    dealStatus: "deal_closed",
                };
                console.log("Updating deal with data:", updateData);
                await updateDeal(dealData.ROWID, updateData);

                // window.location.reload();
            }
        } catch (error) {
            toast.error("Error in status updation");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleRejectConfirm = async () => {
        try {
            setIsSubmitting(true);

            if (!quoteId || quoteId === "") {
                toast({
                    title: "Error",
                    description: "Quotation information is missing",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
                return;
            }

            // First, reject the quote
            const rejectResponse = await rejectQuote(quoteId, { comment: rejectComment });

            if (rejectResponse.data.success) {
               
                const noteData = {
                    notes: rejectComment, 
                    quote: quoteId, 
                    lead: null,
                    deal: null,
                    contact: null,
                    company: null
                };

                console.log("Creating note with data:", noteData);

                // Call the addNotes API
                const noteResponse = await addNotes(noteData);

                if (noteResponse.data.success) {
                    toast.success("Quotation rejected successfully and note created");
                } else {
                    // Note creation failed but quote was rejected
                    toast.success("Quotation rejected successfully but note creation failed");
                }
                const updateData = {
                    ...dealData ,
                    createdBy: dealData?.createdBy.ROWID || null,
                    modifiedBy: dealData?.modifiedBy.ROWID || null,
                    dealStatus: "quote_rejected",
                };
                await updateDeal(dealData.ROWID, updateData);
                setIsRejectModalOpen(false);

                setRejectComment(""); // Clear the comment
                // window.location.reload();
            }
        } catch (error) {
            console.error("Error in rejection process:", error);
            toast.error("Error in rejection process");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleModalClose = () => {
        setIsApproveModalOpen(false);
        setIsRejectModalOpen(false);
        setRejectComment(""); // Clear comment when modal closes
    };

    return (
        <Box w="100%" h="100vh" overflowY="auto" position="relative" className="bg-white">
            {loading && (
                <div className="spinner-overlay">
                    <Spinner size="xl" color="#011638" />
                </div>
            )}
            <Box h="16" bg="white" width="stretch" zIndex="10" px={8}>
                <div className="mx-1 pl-3">
                    <Flex align="center" justify="space-between" gap={3} w="100%" h="16">
                        <Text fontSize="xl" fontWeight="semibold" whiteSpace="nowrap">
                            {estimate.quoteNo || "EST-25-5256"}
                        </Text>
                    </Flex>
                </div>
                <div className="mx-1 bg-white pl-3">
                    <Box display="flex">
                        <Button
                            variant="outline"
                            borderRadius="0"
                            className="flex gap-1 items-center justify-center"
                            onClick={handleApproveClick}
                        >
                            <CheckCircle color="green" size={18} />
                            APPROVED
                        </Button>

                        <Button
                            variant="outline"
                            borderRadius="0"
                            className="flex gap-1 items-center justify-center"
                            onClick={handleRejectClick}
                        >
                            <XCircle color="red" size={18} />
                            REJECTED
                        </Button>
                    </Box>
                </div>

                {/* Approve Confirmation Modal */}
                <Modal isOpen={isApproveModalOpen} onClose={handleModalClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Confirm Approval</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <Text>Are you sure you want to approve this quotation?</Text>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="ghost" mr={3} onClick={handleModalClose}>
                                Cancel
                            </Button>
                            <Button
                                colorScheme="green"
                                onClick={handleApproveConfirm}
                                isLoading={isSubmitting}
                                loadingText="Approving..."
                            >
                                Approve
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                {/* Reject Modal with Comment Field */}
                <Modal isOpen={isRejectModalOpen} onClose={handleModalClose}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Reject Quotation</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <Text mb={4}>Please provide a reason for rejection:</Text>
                            <FormControl isRequired>
                                <FormLabel>Rejection Reason</FormLabel>
                                <Textarea
                                    placeholder="Enter rejection reason..."
                                    value={rejectComment}
                                    onChange={(e) => setRejectComment(e.target.value)}
                                    rows={4}
                                />
                            </FormControl>
                        </ModalBody>
                        <ModalFooter>
                            <Button variant="ghost" mr={3} onClick={handleModalClose}>
                                Cancel
                            </Button>
                            <Button
                                colorScheme="red"
                                onClick={handleRejectConfirm}
                                isLoading={isSubmitting}
                                loadingText="Rejecting..."
                                isDisabled={!rejectComment.trim()} // Disable if comment is empty
                            >
                                Reject
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                {/* Rest of your component remains the same */}
                <div className="mb-32">
                    <div className="">
                        <div
                            ref={componentRef}
                            className="pdf-container custom-scroll w-full"
                            style={{
                                maxHeight: "100vh",
                                minWidth: "100%",
                                overflowY: "auto",
                                backgroundColor: "white",
                                borderRadius: "5px",
                            }}
                        >
                            <div className="pdf-header w-full p-0">
                                <Box mb={20} w="full">
                                    <Card borderWidth="1px" borderColor="gray.200" boxShadow="sm" w="full">
                                        <CardBody p={4} w="full">
                                            <Stack spacing={6} fontSize="sm" color="gray.700">
                                                {/* Header Landscape */}
                                                <Flex
                                                    direction="row"
                                                    justify="space-between"
                                                    align="start"
                                                >
                                                    <Flex direction="row" gap={4}>
                                                        {/* <Image
                                                            src={logoImageUrl}
                                                            alt="Logo"
                                                            maxWidth="80px"
                                                            maxHeight="80px"
                                                            fallback={
                                                                <Image
                                                                    src="https://i.postimg.cc/d1tpgLGb/loginlogo.webp"
                                                                    alt="Default Logo"
                                                                    width="180px"
                                                                />
                                                            }
                                                        /> */}
                                                    </Flex>
                                                    <Box fontSize="sm">
                                                        <Text
                                                            fontWeight="semibold"
                                                            marginBottom="0 !important"
                                                        >
                                                            {orgDetailData?.organisationName}
                                                        </Text>
                                                        <Text marginBottom="0 !important">
                                                            {orgDetailData?.organisationLocation +
                                                                " " +
                                                                orgDetailData?.orgStreet}
                                                        </Text>
                                                        <Text marginBottom="0 !important">
                                                            {orgDetailData?.orgArea +
                                                                " " +
                                                                orgDetailData?.orgCity}
                                                        </Text>
                                                        <Text marginBottom="0 !important">
                                                            {orgDetailData?.orgState +
                                                                " - " +
                                                                orgDetailData?.orgZipCode}
                                                        </Text>
                                                    </Box>

                                                    <Box textAlign="right">
                                                        <Heading size="md">Quote</Heading>
                                                        <Text fontWeight="semibold" fontSize="sm">
                                                            Quote #{estimate.quoteNo}
                                                        </Text>
                                                    </Box>
                                                </Flex>

                                                {/* Bill To + Ship To side by side */}
                                                <Flex
                                                    justify="space-between"
                                                    align="flex-start"
                                                    direction="row"
                                                >
                                                    <Box fontSize="sm">
                                                        <Text fontWeight="semibold" mb={1}>
                                                            Bill To
                                                        </Text>
                                                        <Text>{clientName(billTo.name)}</Text>
                                                        {billTo.address.map((line, i) => (
                                                            <Text key={i}>{line}</Text>
                                                        ))}
                                                    </Box>

                                                    <Box fontSize="sm">
                                                        <Text fontWeight="semibold">Ship To</Text>
                                                        <Text>{clientName(shipTo.name)}</Text>
                                                        {shipTo.address.map((line, i) => (
                                                            <Text key={i}>{line}</Text>
                                                        ))}
                                                    </Box>

                                                    <Box>
                                                        <Table variant="unstyled" size="sm">
                                                            <Tbody>
                                                                <Tr>
                                                                    <Td>Quote Date</Td>
                                                                    <Td>:</Td>
                                                                    <Td>{estimate.date}</Td>
                                                                </Tr>
                                                                <Tr>
                                                                    <Td>Reference Number</Td>
                                                                    <Td>:</Td>
                                                                    <Td>{estimate.reference}</Td>
                                                                </Tr>
                                                                <Tr>
                                                                    <Td>Client Reference Number</Td>
                                                                    <Td>:</Td>
                                                                    <Td>{estimate.clientReferenceNo || "N/A"}</Td>
                                                                </Tr>
                                                            </Tbody>
                                                        </Table>
                                                    </Box>
                                                </Flex>

                                                {/* Item Table */}
                                                <TableContainer border="1px solid"
                                                    borderColor="gray.300" borderRadius="md">
                                                    <Table size="md" tableLayout="fixed">
                                                        <Thead bg="gray.100">
                                                            <Tr sx={{ th: { p: 2, textAlign: "center", verticalAlign: 'center' } }}>
                                                                <Th fontSize="xs">Shade No.</Th>
                                                                <Th fontSize="xs">Items</Th>
                                                                <Th fontSize="xs">HSN Code</Th>
                                                                {isWidthandDropVisible ? (
                                                                    <Th fontSize="xs">Unit</Th>
                                                                ) : null}
                                                                {isWidthandDropVisible ? (
                                                                    <Th fontSize="xs">Width</Th>
                                                                ) : null}
                                                                {isWidthandDropVisible ? (
                                                                    <Th fontSize="xs">Drop</Th>
                                                                ) : null}
                                                                <Th fontSize="xs">Operation</Th>
                                                                <Th fontSize="xs">Area(Sq mtr)</Th>
                                                                <Th fontSize="xs">Qty</Th>
                                                                <Th fontSize="xs">Rate</Th>
                                                                <Th fontSize="xs">Motor </Th>
                                                                <Th fontSize="xs">Colour</Th>
                                                                <Th fontSize="xs">Discount</Th>
                                                                {/* <Th fontSize="xs">Tax</Th> */}
                                                                <Th fontSize="xs">Amount</Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            {items.map((item, index) => (
                                                                <Tr key={item.ROWID || index} sx={{ td: { py: 2, px: 0, textAlign: "center", verticalAlign: 'center' } }}>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {shadName(item.shadeNo)}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {itemName(item.productDescription)}
                                                                    </Td>

                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {item.hsnCode}
                                                                    </Td>
                                                                    {isWidthandDropVisible ? (
                                                                        <Td
                                                                            whiteSpace="normal"
                                                                            wordBreak="break-word"
                                                                            fontSize="xs"
                                                                        >
                                                                            {item.unit}
                                                                        </Td>
                                                                    ) : null}
                                                                    {isWidthandDropVisible ? (
                                                                        <Td
                                                                            whiteSpace="normal"
                                                                            wordBreak="break-word"
                                                                            fontSize="xs"
                                                                        >
                                                                            {item.width}
                                                                        </Td>
                                                                    ) : null}
                                                                    {isWidthandDropVisible ? (
                                                                        <Td
                                                                            whiteSpace="normal"
                                                                            wordBreak="break-word"
                                                                            fontSize="xs"
                                                                        >
                                                                            {item.drops}
                                                                        </Td>
                                                                    ) : null}
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {item.operations}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {item.area}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {item.quantity}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        fontSize="xs"
                                                                    >
                                                                        ₹{item.rate}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {motorMap[item.motorId]?.name || "-"}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {colourMap[item.mechanismColor] || "-"}
                                                                    </Td>
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {item.discount}%
                                                                    </Td>
                                                                    {/* <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        {item.taskRate}%
                                                                    </Td> */}
                                                                    <Td
                                                                        whiteSpace="normal"
                                                                        wordBreak="break-word"
                                                                        fontSize="xs"
                                                                    >
                                                                        ₹{item.amount}
                                                                    </Td>
                                                                </Tr>
                                                            ))}
                                                        </Tbody>
                                                    </Table>
                                                </TableContainer>

                                                {/* Totals */}
                                                <Flex justify="space-between" align="flex-start" mt={2} mb={4} gap={2}>
                                                    <Box fontSize="sm" border="1px solid"
                                                        borderColor="gray.300"
                                                        borderRadius="md" p={2}>
                                                        <Text fontWeight="semibold" marginBottom={0}>
                                                            Terms And Conditions
                                                        </Text>
                                                        <Text whiteSpace="pre-line">
                                                            {termsText || "No Terms & Conditions available."}
                                                        </Text>
                                                    </Box>
                                                    <Box width="260px" border="1px solid"
                                                        borderColor="gray.300" borderRadius="md">
                                                        <Flex justify="space-between" p={2}>
                                                            <Text fontWeight="semibold" mb={0}>Sub Total</Text>
                                                            <Text mb={0}>₹{estimate.subTotal}</Text>
                                                        </Flex>
                                                        {estimate.shippingCharges && (
                                                            <Flex justify="space-between" p={2}>
                                                                <Text mb={0}>Shipping Charges</Text>
                                                                <Text mb={0}>₹{estimate.shippingCharges}</Text>
                                                            </Flex>
                                                        )}
                                                        {estimate.roundOff && (
                                                            <Flex justify="space-between" p={2}>
                                                                <Text mb={0}>Round Off</Text>
                                                                <Text mb={0}>₹{estimate.roundOff}</Text>
                                                            </Flex>
                                                        )}
                                                        <Flex
                                                            justify="space-between"
                                                            p={2}
                                                            fontWeight="bold"
                                                            borderTopWidth="2px"
                                                            borderColor="gray.100"
                                                        >
                                                            <Text mb={0}>Total</Text>
                                                            <Text mb={0}>₹{estimate.total}</Text>
                                                        </Flex>
                                                    </Box>
                                                </Flex>

                                                <Text mb={0} fontWeight="semibold">Bank Details </Text>

                                                <Table variant="unstyled" size="sm">
                                                    <Tbody>
                                                        <Tr sx={{ td: { py: 1, px: 0 } }}>
                                                            <Td color="gray.700">Bank Name:</Td>
                                                            <Td>{orgDetailData?.bankName || "-"}</Td>
                                                        </Tr>
                                                        <Tr sx={{ td: { py: 1, px: 0 } }}>
                                                            <Td color="gray.700">Account Number:</Td>
                                                            <Td>{orgDetailData?.accountNumber || "-"}</Td>
                                                        </Tr>
                                                        <Tr sx={{ td: { py: 1, px: 0 } }}>
                                                            <Td color="gray.700">IFSC Code:</Td>
                                                            <Td>{orgDetailData?.ifscCode || "-"}</Td>
                                                        </Tr>
                                                        <Tr sx={{ td: { py: 1, px: 0 } }}>
                                                            <Td color="gray.700">PAN No:</Td>
                                                            <Td>{orgDetailData?.panNumber || "-"}</Td>
                                                        </Tr>
                                                        {estimate.quoteType === "Domastic" && (
                                                            <Tr sx={{ td: { py: 1, px: 0 } }}>
                                                                <Td color="gray.700">Swift Code:</Td>
                                                                <Td>{orgDetailData?.swiftCode || "-"}</Td>
                                                            </Tr>
                                                        )}
                                                        <Tr sx={{ td: { py: 1, px: 0 } }}>
                                                            <Td color="gray.700">GST No:</Td>
                                                            <Td>{orgDetailData?.gstNumber || "-"}</Td>
                                                        </Tr>
                                                    </Tbody>
                                                </Table>
                                            </Stack>
                                        </CardBody>
                                    </Card>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        </Box>
    );
}

// import React, { useMemo, useRef, useState } from "react";
// import {
//     Box,
//     Flex,
//     Button,
//     Text,
//     Table,
//     Thead,
//     Tbody,
//     Tr,
//     Th,
//     Td,
//     Heading,
//     Stack,
//     TableContainer,
//     Image,
//     Card,
//     CardBody,
//     useToast,
//     Spinner,
// } from "@chakra-ui/react";
// import {
//     XCircle,
//     CheckCircle,
// } from "lucide-react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import {
//     getQuoteDetailById,
//     sendQuoteEmail,
// } from "../../../../redux/api/admin/quoteApi";
// import { useEffect } from "react";
// import { getProduct } from "../../../../redux/reduxApi/admin/ProductReduxApi";
// import { useDispatch, useSelector } from "react-redux";
// import "./QuoteDetail.css";
// import { toast } from "react-toastify";

// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";
// import { getClientList } from "../../../../redux/reduxApi/admin/ClientReduxApi";
// import { getCategoryList } from "../../../../redux/reduxApi/admin/CategoryReduxApi";
// import { getShadeNumberList } from "../../../../redux/reduxApi/admin/ShadeReduxApi";
// import { getOrganisationDetailById } from "../../../../redux/api/admin/OrgApi";
// import { getTermsAndConditionList } from "../../../../redux/reduxApi/admin/termsAndConditionsListRedux";
// import { getMotorsList } from "../../../../redux/reduxApi/admin/MotorizationReduxApi";
// import { getColoursList } from "../../../../redux/reduxApi/admin/ColourReduxApi";
// import { getEmployeesList } from "../../../../redux/reduxApi/admin/EmployeesReduxApi";
// import { approveQuote, rejectQuote } from "../../../../redux/api/admin/quoteApi";
// export default function QuotePublicDetail({ }) {
//     const componentRef = useRef();
//     const { id } = useParams();
//     const dispatch = useDispatch();
//     const navigate = useNavigate();
//     const quoteId = id;
//     // const toast = useToast();
//     console.log("quoteId", quoteId);


//     const [loading, setLoading] = useState(false);
//     const [items, setItems] = useState([]);
//     const [estimate, setEstimate] = useState({});
//     const [billTo, setBillTo] = useState({ name: "", address: [] });
//     const [shipTo, setShipTo] = useState({ name: "", address: [] });
//     const categoryList = useSelector((state) => state.category.category);
//     const [employees, setEmployees] = useState([]);
//     const [quoteDataNew, setQuoteDataNew] = useState([]);
//     console.log("quoteDataNew", quoteDataNew);
//     const [termsText, setTermsText] = useState("");
//     const [motorData, setMotorData] = useState([]);
//     const [colourData, setColourData] = useState([]);

//     const formatDate = (dateString) => {
//         if (!dateString) return "";
//         const date = new Date(dateString);
//         return date.toLocaleDateString("en-GB");
//     };

//     useEffect(() => {
//         if (quoteDataNew?.termsAndCondition) {
//             dispatch(getTermsAndConditionList({ size: 100 }))
//                 .then((res) => {
//                     const list = res?.payload?.data?.termAndConditions || [];

//                     const matched = list.find(
//                         (item) =>
//                             String(item.ROWID) ===
//                             String(quoteDataNew.termsAndCondition)
//                     );

//                     if (matched) {
//                         setTermsText(matched.termsAndConditions);
//                     }
//                 })
//                 .catch((err) => {
//                     console.error("Error fetching terms:", err);
//                 });
//         }
//     }, [quoteDataNew?.termsAndCondition, dispatch]);


//     useEffect(() => {
//         if (quoteId) {
//             setLoading(true);
//             getQuoteDetailById(quoteId)
//                 .then((response) => {
//                     console.log("GetQuoteById---->", response);
//                     if (response.data.success) {
//                         const quoteData = response.data.quotation;
//                         console.log("Quote Data:", quoteData);
//                         setQuoteDataNew(quoteData); // Set the quote data

//                         // Map the API data to component state
//                         setItems(quoteData.items || []);

//                         // Set estimate data
//                         setEstimate({
//                             date: formatDate(quoteData.quoteDate),
//                             expiry: "", // You might need to calculate this or get from API
//                             reference: quoteData.refrenceNo,
//                             quoteNo: quoteData.quoteNo,
//                             subTotal: quoteData.subTotal,
//                             total: quoteData.total,
//                             shippingCharges: quoteData.shippingCharges,
//                             roundOff: quoteData.roundOff,
//                             status: quoteData.status,
//                             quoteOwner: quoteData.quoteOwner,
//                             checkedBy: quoteData.checkedBy,
//                             clientReferenceNo: quoteData.clientReferenceNo,
//                         });

//                         setBillTo({
//                             name: quoteData.customerName || "",
//                             address: [quoteData.email || ""].filter((line) => line),
//                         });

//                         setShipTo({
//                             name: quoteData.customerName || "",
//                             address: [
//                                 quoteData.recipientPhnNo
//                                     ? `Phone: ${quoteData.recipientPhnNo}`
//                                     : "",
//                             ].filter((line) => line),
//                         });
//                     }
//                 })
//                 .catch((error) => {
//                     console.log({ error });
//                     toast({
//                         title: "Error fetching quote details",
//                         status: "error",
//                         duration: 3000,
//                         isClosable: true,
//                     });
//                 })
//                 .finally(() => {
//                     setLoading(false);
//                 });
//         }
//     }, [quoteId, toast]);

//     useEffect(() => {
//         dispatch(getMotorsList({ page: 1, size: 100 }))
//             .then((response) => {
//                 const motors = response?.payload?.data?.motors || [];
//                 setMotorData(motors);
//             })
//             .catch((error) => {
//                 console.error("Error fetching motors:", error);
//             });
//     }, [dispatch]);

//     useEffect(() => {
//         dispatch(getColoursList())
//             .then((response) => {
//                 const colours = response?.payload?.data?.colours || [];
//                 setColourData(colours);
//             })
//             .catch((error) => {
//                 console.error("Error fetching motors:", error);
//             });
//     }, [dispatch]);

//     useEffect(() => {
//         dispatch(getEmployeesList({ page: 1, size: 100, limit: 100 }))
//             .then((res) => {
//                 const data = res?.payload?.data?.employees || [];
//                 setEmployees(data);
//             })
//             .catch((err) => {
//                 console.error("Error fetching employees:", err);
//             });
//     }, [dispatch]);

//     // Calculate total quantity from items
//     const calculateTotalQuantity = () => {
//         return items.reduce(
//             (total, item) => total + (parseFloat(item.quantity) || 0),
//             0,
//         );
//     };

//     // Calculate total discount from items
//     const calculateTotalDiscount = () => {
//         return items.reduce(
//             (total, item) => total + (parseFloat(item.discount) || 0),
//             0,
//         );
//     };

//     // Inventory data fetching (your existing code)
//     const [inventoryData, setInventoryData] = useState([]);
//     const [inventoryAllData, setinventoryAllData] = useState([]);
//     console.log("inventoryAllData", inventoryAllData);

//     const [currentPage] = useState(1);


//     useEffect(() => {
//         dispatch(getProduct({ page: currentPage, size: 30, limit: 30 }))
//             .then((response) => {
//                 console.log("response--->", response);
//                 console.log("inventoryData-->", response.payload.inventory || []);
//                 setInventoryData(response.payload.inventory || []);
//             })
//             .catch((error) => {
//                 console.error("Error fetching Company data:", error);
//             });
//     }, [dispatch]);

//     const inventoryLookUp = useMemo(() => {
//         return inventoryData?.map((item) => ({
//             label: item?.itemName,
//             value: item.ROWID,
//             shadeNumber: item?.shadeNumber,
//             hscCode: item?.hscCode,
//         }));
//     }, [inventoryData]);

//     useEffect(() => {
//         if (!inventoryLookUp) {
//             return;
//         }
//         setinventoryAllData(inventoryLookUp);
//     }, [inventoryLookUp]);

//     const itemName = (id) => {
//         const itemData = inventoryAllData.filter((item) => item?.value === id);
//         return itemData[0]?.label;
//     };

//     const [shadeData, setShadeAllData] = useState([]);
//     console.log("shadeData", shadeData);

//     useEffect(() => {
//         dispatch(getShadeNumberList({ page: currentPage, size: 30, limit: 30 }))
//             .then((response) => {
//                 console.log("response", response);

//                 const data = response.payload?.data?.shades || [];

//                 console.log("data", response.payload);

//                 setShadeAllData(data);
//             })
//             .catch((error) => {
//                 console.error("Error fetching Company data:", error);
//             });
//     }, [dispatch]);

//     const shadeDataLookUp = useMemo(() => {
//         return shadeData?.map((item) => ({
//             label: item.shadeNo,
//             value: item.ROWID,
//         }));
//     }, [shadeData]);

//     console.log("shadeDataLookUp", shadeDataLookUp);

//     const shadName = (rowid) => {
//         const itemData = shadeDataLookUp.filter((item) => item?.value === rowid);
//         return itemData[0]?.label;
//     };

//     const [categoryOptions, setCategoryOptions] = useState([]);
//     console.log("categoryOptions", categoryOptions);

//     // Fetch category list for parent category dropdown
//     useEffect(() => {
//         dispatch(getCategoryList());
//     }, [dispatch]);

//     // Prepare category options for dropdown
//     useEffect(() => {
//         const options = categoryList.map((item) => ({
//             label: item.name,
//             value: item.ROWID,
//         }));

//         setCategoryOptions(options);
//     }, [categoryList]);

//     const categoryName = (id) => {
//         const itemData = categoryOptions.filter((item) => item?.value === id);
//         return itemData[0]?.label;
//     };


//     // Inventory data fetching (your existing code)
//     const [clientData, setClientData] = useState([]);

//     useEffect(() => {
//         dispatch(getClientList({ page: currentPage, size: 30, limit: 30 }))
//             .then((response) => {
//                 // console.log("response--->",response);
//                 console.log("inventoryData-->", response.payload?.data?.contact || []);
//                 setClientData(response.payload?.data?.contact || []);
//             })
//             .catch((error) => {
//                 console.error("Error fetching Company data:", error);
//             });
//     }, [dispatch]);

//     const clientLookUp = useMemo(() => {
//         return clientData?.map((item) => ({
//             label: `${item?.firstName} ${item?.lastName}` || "Unnamed Client",
//             value: item.ROWID,
//         }));
//     }, [clientData]);
//     console.log("clientLookUp", clientLookUp);

//     const motorMap = useMemo(() => {
//         const map = {};
//         motorData.forEach(item => {
//             map[item.ROWID] = {
//                 name: item.motorName,
//                 price: item.motorPrice
//             };
//         });
//         return map;
//     }, [motorData]);


//     const colourMap = useMemo(() => {
//         const map = {};
//         colourData.forEach(item => {
//             map[item.ROWID] = item.colour;
//         });
//         return map;
//     }, [colourData]);

//     const employeeMap = useMemo(() => {
//         const map = {};
//         employees.forEach((emp) => {
//             map[emp.ROWID] =
//                 `${emp.firstName || ""} ${emp.lastName || ""}`.trim();
//         });
//         return map;
//     }, [employees]);

//     const clientName = (rowid) => {
//         const itemData = clientLookUp.filter((item) => item?.value === rowid);
//         return itemData[0]?.label;
//     };



//     const organisationId = quoteDataNew?.organisationName || null;
//     console.log("Organisation ID:", organisationId);

//     const [orgDetailData, setOrgDetailData] = useState(null);
//     console.log("orgDetailData", orgDetailData);

//     useEffect(() => {
//         if (organisationId) {
//             setLoading(true);
//             getOrganisationDetailById(organisationId)
//                 .then((response) => {
//                     console.log("GetQuoteById---->", response);
//                     if (response.data.success) {
//                         const orgData = response.data.organisation;
//                         setOrgDetailData(orgData);
//                     }
//                 })
//                 .catch((error) => {
//                     console.log({ error });
//                     toast({
//                         title: "Error fetching quote details",
//                         status: "error",
//                         duration: 3000,
//                         isClosable: true,
//                     });
//                 })
//                 .finally(() => {
//                     setLoading(false);
//                 });
//         }
//     }, [organisationId, toast]);

//     // Add this helper function to parse the logoUrl string
//     const parseLogoUrl = (logoUrlString) => {
//         if (!logoUrlString) return null;

//         try {
//             // The logoUrl is a string that looks like an object
//             // We need to convert it to a proper object
//             // Remove the curly braces and split by commas
//             const cleanStr = logoUrlString.replace(/[{}]/g, "");
//             const pairs = cleanStr.split(", ");

//             const logoObj = {};
//             pairs.forEach((pair) => {
//                 const [key, ...valueParts] = pair.split("=");
//                 const value = valueParts.join("="); // In case the value contains '='
//                 logoObj[key.trim()] = value.trim();
//             });

//             return logoObj.filePath || null;
//         } catch (error) {
//             console.error("Error parsing logoUrl:", error);
//             return null;
//         }
//     };

//     // Then in your component, use it like this:
//     const logoImageUrl = orgDetailData?.logoUrl
//         ? parseLogoUrl(orgDetailData.logoUrl)
//         : "https://i.postimg.cc/d1tpgLGb/loginlogo.webp"; // fallback image

//     const isWidthandDropVisible = quoteDataNew?.isShowDropandWidthinPdf || false;

//     const handleApproveQuotation = async () => {
//         try {
//             setLoading(true)
//             if (!quoteId || quoteId === "") {
//                 toast({
//                     title: "Error",
//                     description: "Quotation information is missing",
//                     status: "error",
//                     duration: 3000,
//                     isClosable: true,
//                 });
//                 return;
//             }
//             const response = await approveQuote(quoteId);
//             if (response.data.success) {
//                 toast.success("Quotation approved successfully")
//             }
//         } catch (error) {
//             toast.error("Error in status updation")
//         } finally {
//             setLoading(false);
//         }
//     }
//     const handleRejectQuotation = async () => {
//         try {
//             setLoading(true)
//             if (!quoteId || quoteId === "") {
//                 toast({
//                     title: "Error",
//                     description: "Quotation information is missing",
//                     status: "error",
//                     duration: 3000,
//                     isClosable: true,
//                 });
//                 return;
//             }
//             const response = await rejectQuote(quoteId);
//             if (response.data.success) {
//                 toast.success("Quotation rejected successfully")
//             }
//         } catch (error) {
//             toast.error("Error in status updation")
//         } finally {
//             setLoading(false);
//         }
//     }
//     return (
//         <Box w="100%" h="100vh" overflowY="auto" position="relative" className="bg-white">
//             {loading && (
//                 <div className="spinner-overlay">
//                     <Spinner size="xl" color="#011638" />
//                 </div>
//             )}
//             <Box h="16" bg="white" width="stretch" zIndex="10" px={8}>
//                 <div className="mx-1 pl-3">
//                     <Flex align="center" justify="space-between" gap={3} w="100%" h="16">
//                         <Text fontSize="xl" fontWeight="semibold" whiteSpace="nowrap">
//                             {estimate.quoteNo || "EST-25-5256"}
//                         </Text>
//                     </Flex>
//                 </div>
//                 <div className="mx-1 bg-white pl-3">
//                     <Box display="flex">
//                         <Button
//                             variant="outline"
//                             borderRadius="0"
//                             className="flex gap-1 items-center justify-center"
//                             onClick={handleApproveQuotation}
//                         >
//                             <CheckCircle color="green" size={18} />
//                             APPROVED
//                         </Button>

//                         <Button
//                             variant="outline"
//                             borderRadius="0"
//                             className="flex gap-1 items-center justify-center"
//                             onClick={handleRejectQuotation}
//                         >
//                             <XCircle color="red" size={18} />
//                             REJECTED
//                         </Button>
//                     </Box>
//                 </div>

//                 <div className="mb-32">
//                     <div className="">
//                         <div
//                             ref={componentRef}
//                             className="pdf-container custom-scroll w-full"
//                             style={{
//                                 maxHeight: "100vh",
//                                 minWidth: "100%",
//                                 overflowY: "auto",
//                                 backgroundColor: "white",
//                                 borderRadius: "5px",
//                             }}
//                         >
//                             <div className="pdf-header w-full p-0">
//                                 <Box mb={20} w="full"   >
//                                     <Card borderWidth="1px" borderColor="gray.200" boxShadow="sm" w="full">
//                                         <CardBody p={4} w="full">
//                                             <Stack spacing={6} fontSize="sm" color="gray.700">
//                                                 {/* Header Landscape */}
//                                                 <Flex
//                                                     direction="row"
//                                                     justify="space-between"
//                                                     align="start"
//                                                 >
//                                                     <Flex direction="row" gap={4}>
//                                                         <Image
//                                                             src={logoImageUrl}
//                                                             alt="Logo"
//                                                             maxWidth="80px"
//                                                             maxHeight="80px"
//                                                             fallback={
//                                                                 <Image
//                                                                     src="https://i.postimg.cc/d1tpgLGb/loginlogo.webp"
//                                                                     alt="Default Logo"
//                                                                     width="180px"
//                                                                 />
//                                                             }
//                                                         />
//                                                     </Flex>
//                                                     <Box fontSize="sm">
//                                                         <Text
//                                                             fontWeight="semibold"
//                                                             marginBottom="0 !important"
//                                                         >
//                                                             {orgDetailData?.organisationName}
//                                                         </Text>
//                                                         <Text marginBottom="0 !important">
//                                                             {orgDetailData?.organisationLocation +
//                                                                 " " +
//                                                                 orgDetailData?.orgStreet}
//                                                         </Text>
//                                                         <Text marginBottom="0 !important">
//                                                             {orgDetailData?.orgArea +
//                                                                 " " +
//                                                                 orgDetailData?.orgCity}
//                                                         </Text>
//                                                         <Text marginBottom="0 !important">
//                                                             {orgDetailData?.orgState +
//                                                                 " - " +
//                                                                 orgDetailData?.orgZipCode}
//                                                         </Text>
//                                                     </Box>

//                                                     <Box textAlign="right">
//                                                         <Heading size="md">Quote</Heading>
//                                                         <Text fontWeight="semibold" fontSize="sm">
//                                                             Quote #{estimate.quoteNo}
//                                                         </Text>
//                                                     </Box>
//                                                 </Flex>

//                                                 {/* Bill To + Ship To side by side */}
//                                                 <Flex
//                                                     justify="space-between"
//                                                     align="flex-start"
//                                                     direction="row"
//                                                 >
//                                                     <Box fontSize="sm">
//                                                         <Text fontWeight="semibold" mb={1}>
//                                                             Bill To
//                                                         </Text>
//                                                         <Text>{clientName(billTo.name)}</Text>
//                                                         {billTo.address.map((line, i) => (
//                                                             <Text key={i}>{line}</Text>
//                                                         ))}
//                                                     </Box>

//                                                     <Box fontSize="sm">
//                                                         <Text fontWeight="semibold">Ship To</Text>
//                                                         <Text>{clientName(shipTo.name)}</Text>
//                                                         {shipTo.address.map((line, i) => (
//                                                             <Text key={i}>{line}</Text>
//                                                         ))}
//                                                     </Box>

//                                                     <Box>
//                                                         <Table variant="unstyled" size="sm">
//                                                             <Tbody>
//                                                                 <Tr>
//                                                                     <Td>Quote Date</Td>
//                                                                     <Td>:</Td>
//                                                                     <Td>{estimate.date}</Td>
//                                                                 </Tr>
//                                                                 <Tr>
//                                                                     <Td>Reference Number</Td>
//                                                                     <Td>:</Td>
//                                                                     <Td>{estimate.reference}</Td>
//                                                                 </Tr>
//                                                                 <Tr>
//                                                                     <Td>Client Reference Number</Td>
//                                                                     <Td>:</Td>
//                                                                     <Td>{estimate.clientReferenceNo || "N/A"}</Td>
//                                                                 </Tr>
//                                                             </Tbody>
//                                                         </Table>
//                                                     </Box>
//                                                 </Flex>

//                                                 {/* Item Table */}
//                                                 <TableContainer border="1px solid"
//                                                     borderColor="gray.300" borderRadius="md">
//                                                     <Table size="md" tableLayout="fixed">
//                                                         <Thead bg="gray.100" >
//                                                             <Tr sx={{ th: { p: 2, textAlign: "center", verticalAlign: 'center' } }}>
//                                                                 {/* <Th fontSize="xs">Category</Th> */}
//                                                                 {/* <Th fontSize="xs">Sub Category</Th> */}
//                                                                 <Th fontSize="xs">Shade No.</Th>
//                                                                 <Th fontSize="xs">Items</Th>
//                                                                 <Th fontSize="xs">HSN Code</Th>
//                                                                 {isWidthandDropVisible ? (
//                                                                     <Th fontSize="xs">Unit</Th>
//                                                                 ) : null}
//                                                                 {isWidthandDropVisible ? (
//                                                                     <Th fontSize="xs">Width</Th>
//                                                                 ) : null}
//                                                                 {isWidthandDropVisible ? (
//                                                                     <Th fontSize="xs">Drop</Th>
//                                                                 ) : null}
//                                                                 <Th fontSize="xs">Operation</Th>
//                                                                 <Th fontSize="xs">Area(Sq ft)</Th>
//                                                                 <Th fontSize="xs">Qty</Th>
//                                                                 <Th fontSize="xs">Rate</Th>
//                                                                 <Th fontSize="xs">Motor </Th>
//                                                                 <Th fontSize="xs">Colour</Th>
//                                                                 <Th fontSize="xs">Discount</Th>
//                                                                 <Th fontSize="xs">Tax</Th>
//                                                                 <Th fontSize="xs">Amount</Th>
//                                                             </Tr>
//                                                         </Thead>
//                                                         <Tbody>
//                                                             {items.map((item, index) => (
//                                                                 <Tr key={item.ROWID || index} sx={{ td: { py: 2, px: 0, textAlign: "center", verticalAlign: 'center' } }}>
//                                                                     {/* <Td>{item.productDescription}</Td>
//                                                             <Td>{item.shadeNo}</Td> */}
//                                                                     {/* <Td  whiteSpace="normal" wordBreak="break-word" fontSize="xs">{item.category}</Td> */}
//                                                                     {/* <Td  whiteSpace="normal" wordBreak="break-word" fontSize="xs">{item.subCategory}</Td> */}
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {shadName(item.shadeNo)}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {itemName(item.productDescription)}
//                                                                     </Td>

//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {item.hsnCode}
//                                                                     </Td>
//                                                                     {isWidthandDropVisible ? (
//                                                                         <Td
//                                                                             whiteSpace="normal"
//                                                                             wordBreak="break-word"
//                                                                             fontSize="xs"
//                                                                         >
//                                                                             {item.unit}
//                                                                         </Td>
//                                                                     ) : null}
//                                                                     {isWidthandDropVisible ? (
//                                                                         <Td
//                                                                             whiteSpace="normal"
//                                                                             wordBreak="break-word"
//                                                                             fontSize="xs"
//                                                                         >
//                                                                             {item.width}
//                                                                         </Td>
//                                                                     ) : null}
//                                                                     {isWidthandDropVisible ? (
//                                                                         <Td
//                                                                             whiteSpace="normal"
//                                                                             wordBreak="break-word"
//                                                                             fontSize="xs"
//                                                                         >
//                                                                             {item.drops}
//                                                                         </Td>
//                                                                     ) : null}
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {item.operations}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {item.area}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {item.quantity}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         ₹{item.rate}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {motorMap[item.motorId]?.name || "-"}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {colourMap[item.mechanismColor] || "-"}
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {item.discount}%
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         {item.taskRate}%
//                                                                     </Td>
//                                                                     <Td
//                                                                         whiteSpace="normal"
//                                                                         wordBreak="break-word"
//                                                                         fontSize="xs"
//                                                                     >
//                                                                         ₹{item.amount}
//                                                                     </Td>
//                                                                 </Tr>
//                                                             ))}
//                                                         </Tbody>
//                                                     </Table>
//                                                 </TableContainer>

//                                                 {/* Totals */}
//                                                 <Flex justify="space-between" align="flex-start" mt={2} mb={4} gap={2} >
//                                                     <Box fontSize="sm" border="1px solid"
//                                                         borderColor="gray.300"
//                                                         borderRadius="md" p={2}>
//                                                         <Text fontWeight="semibold" marginBottom={0}>
//                                                             Terms And Conditions
//                                                         </Text>
//                                                         <Text whiteSpace="pre-line" >
//                                                             {termsText || "No Terms & Conditions available."}
//                                                         </Text>
//                                                     </Box>
//                                                     <Box width="260px" border="1px solid"
//                                                         borderColor="gray.300" borderRadius="md" >
//                                                         <Flex justify="space-between" p={2}>
//                                                             <Text fontWeight="semibold" mb={0}>Sub Total</Text>
//                                                             <Text mb={0}>₹{estimate.subTotal}</Text>
//                                                         </Flex>
//                                                         {estimate.shippingCharges && (
//                                                             <Flex justify="space-between" p={2}>
//                                                                 <Text mb={0}>Shipping Charges</Text>
//                                                                 <Text mb={0}>₹{estimate.shippingCharges}</Text>
//                                                             </Flex>
//                                                         )}
//                                                         {estimate.roundOff && (
//                                                             <Flex justify="space-between" p={2}>
//                                                                 <Text mb={0}>Round Off</Text>
//                                                                 <Text mb={0}>₹{estimate.roundOff}</Text>
//                                                             </Flex>
//                                                         )}
//                                                         <Flex
//                                                             justify="space-between"
//                                                             p={2}
//                                                             fontWeight="bold"
//                                                             borderTopWidth="2px"
//                                                             borderColor="gray.100"
//                                                         >
//                                                             <Text mb={0}>Total</Text>
//                                                             <Text mb={0}>₹{estimate.total}</Text>
//                                                         </Flex>
//                                                     </Box>
//                                                 </Flex>

//                                                 <Text mb={0} fontWeight="semibold">Bank Details </Text>

//                                                 <Table variant="unstyled" size="sm" >
//                                                     <Tbody>
//                                                         <Tr sx={{ td: { py: 1, px: 0 } }}>
//                                                             <Td color="gray.700">Bank Name:</Td>
//                                                             <Td>{orgDetailData?.bankName || "-"}</Td>
//                                                         </Tr>
//                                                         <Tr sx={{ td: { py: 1, px: 0 } }}>
//                                                             <Td color="gray.700">Account Number:</Td>
//                                                             <Td>{orgDetailData?.accountNumber || "-"}</Td>
//                                                         </Tr>
//                                                         <Tr sx={{ td: { py: 1, px: 0 } }}>
//                                                             <Td color="gray.700">IFSC Code:</Td>
//                                                             <Td>{orgDetailData?.ifscCode || "-"}</Td>
//                                                         </Tr>
//                                                         <Tr sx={{ td: { py: 1, px: 0 } }}>
//                                                             <Td color="gray.700">PAN No:</Td>
//                                                             <Td>{orgDetailData?.panNumber || "-"}</Td>
//                                                         </Tr>
//                                                         {estimate.quoteType === "Domastic" && (
//                                                             <Tr sx={{ td: { py: 1, px: 0 } }}>
//                                                                 <Td color="gray.700">Swift Code:</Td>
//                                                                 <Td>{orgDetailData?.swiftCode || "-"}</Td>
//                                                             </Tr>
//                                                         )}
//                                                         <Tr sx={{ td: { py: 1, px: 0 } }}>
//                                                             <Td color="gray.700">GST No:</Td>
//                                                             <Td>{orgDetailData?.gstNumber || "-"}</Td>
//                                                         </Tr>
//                                                     </Tbody>
//                                                 </Table>
//                                             </Stack>
//                                         </CardBody>
//                                     </Card>
//                                 </Box>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </Box>
//         </Box>
//     );
// }
